import { render, staticRenderFns } from "./RecordGoal.vue?vue&type=template&id=17234217"
import script from "./RecordGoal.vue?vue&type=script&lang=js"
export * from "./RecordGoal.vue?vue&type=script&lang=js"
import style0 from "./RecordGoal.vue?vue&type=style&index=0&id=17234217&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports